/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Updatehowcustomerscanreachyou5Inputs */

const en_updatehowcustomerscanreachyou5 = /** @type {(inputs: Updatehowcustomerscanreachyou5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update how customers can reach you`)
};

const de_updatehowcustomerscanreachyou5 = /** @type {(inputs: Updatehowcustomerscanreachyou5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändere, wie Gäste dich erreichen.`)
};

/**
* | output |
* | --- |
* | "Update how customers can reach you" |
*
* @param {Updatehowcustomerscanreachyou5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const updatehowcustomerscanreachyou5 = /** @type {((inputs?: Updatehowcustomerscanreachyou5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Updatehowcustomerscanreachyou5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_updatehowcustomerscanreachyou5(inputs)
	return de_updatehowcustomerscanreachyou5(inputs)
});
export { updatehowcustomerscanreachyou5 as "updateHowCustomersCanReachYou" }